import Index from '@/views/subAccount/Index';
import Content from '@/views/subAccount/Content';
import Details from '@/views/subAccount/Details';

export default {
  path: 'sub-accounts',
  component: Index,
  name: 'sub-accounts',
  meta: { title: 'Sub Accounts' },
  children : [
    {
      path: ':subId',
      component: Content,
      meta: { title: 'Sub User' },
      name: 'sub-by-id',
    },
    {
      path: ':subId/details',
      component: Details,
      meta: { title: 'Sub Details' },
      name: 'sub-by-id-details',
    },
  ]
}
